<!--
    @详页内容title
-->
<template>
    <div class="sectiontitle">
        <span class="sectiontitle-title">{{title}}</span>
        <el-divider class="sectiontitle-line"></el-divider>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        }
    }
}
</script>

<style lang="scss" scoped>
.sectiontitle {
    color: #1890FF;
    font-size: 16px;
    .sectiontitle-title {
        position: relative;
        &:after {
            content: '';
            width: 100%;
            height: 2px;
            background-color: #1890FF;
            position: absolute;
            left: 0;
            bottom: -17px;
        }
    }
    .sectiontitle-line {
        background-color: #1890FF;
        margin: 16px 0 24px 0;
    }
}
</style>